import FirestoreService from "../firestore";
import { StoneType } from "@/types/stone-type/stone-type.types";

interface FirestoreResponse {
    entity?: string;
    [key: string]: any;
}

export const stoneTypeService = {
    create: async (body: Omit<StoneType, "id" | "createdAt" | "updatedAt">, issuedBy?: string) => {
        const result = (await FirestoreService.request(
            "create-stoneType",
            body,
            "setup_stoneTypes",
            issuedBy
        )) as FirestoreResponse;

        const documentId = result?.entity;
        if (!documentId) {
            throw new Error("Failed to create stone type: No ID returned");
        }
        return documentId;
    },

    edit: async (id: string, body: Partial<StoneType>, issuedBy?: string) => {
        const result = (await FirestoreService.request(
            "edit-stoneType",
            { id, ...body },
            "setup_stoneTypes",
            issuedBy
        )) as FirestoreResponse;
        return result;
    },

    archive: async (documentId: string, issuedBy?: string) => {
        return FirestoreService.request(
            "archive-stoneType",
            { documentId },
            "setup_stoneTypes",
            issuedBy
        ) as Promise<FirestoreResponse>;
    },

    restore: async (documentId: string, issuedBy?: string) => {
        return FirestoreService.request(
            "restore-stoneType",
            { documentId },
            "setup_stoneTypes",
            issuedBy
        ) as Promise<FirestoreResponse>;
    },
}; 